<div class="modal-content">
  <button aria-label="Close" class="close" type="button" (click)="closeMe()">
    <app-icon name="cross" />
  </button>
  <div
    data-test="insuranceUpsellingModal"
    class="row m-0 overflow-auto"
    [ngClass]="isSmallerThanLarge ? 'mb-1' : 'mb-3'">
    <!-- insurance image -->
    <div class="col-md-5 col-12 p-0 d-none d-md-block">
      <div class="banner-image">
        <img
          [src]="'images/protect-yourself/damage-theft-protection.jpg' | platformasset: true"
          [alt]="'INSURANCE.guaranty_name' | alpitranslate" />
        @if (insuranceForAll()) {
          <div class="banner-price text-uppercase">
            {{
              'INSURANCE.upsellingPrice'
                | alpitranslate
                  : {
                      price: insuranceForAll() | currency: currencyService.actualCurrency
                    }
            }}
            <div class="price-info-text pt-1">
              {{ 'INSURANCE.forAll' | alpitranslate }}
            </div>
          </div>
        }

        <div class="title-wrapper">
          <div class="banner-title">{{ 'INSURANCE.guaranty_name' | alpitranslate }}</div>
          <div class="banner-description-wrapper d-flex flex-column">
            <div class="banner-description-item-wrapper d-flex">
              <div class="banner-description-item">
                {{ 'INSURANCE.cartGuarantyDescription' | alpitranslate }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- clickable person content -->
    <div class="col-md-7 col-12 p-0">
      <div class="modal-header pb-1">
        <h4 class="modal-title">{{ 'INSURANCE.headline' | alpitranslate }}</h4>
      </div>
      <p class="modal-subtitle">
        {{
          'INSURANCE.subheadline'
            | alpitranslate
              : {
                  min_amount_curr: amountWithCurrency[currencyService.actualCurrency].min,
                  max_amount_curr: amountWithCurrency[currencyService.actualCurrency].max
                }
        }}
      </p>
      <div class="modal-body p-0">
        @if (this.products.length) {
          @for (person of cart.persons; track person; let personIndex = $index) {
            <div class="product-wrapper d-flex flex-row">
              <!-- avatar -->
              <div class="product-avatar d-none d-sm-block">
                <app-icon [name]="person.isAdult ? 'ageCategoryadult' : 'ageCategorychild'"></app-icon>
              </div>
              <!-- content row -->
              <div
                class="person-product-wrapper gap-1 d-flex flex-column w-100 justify-content-between align-items-center">
                <!-- name and items-block | add-protection button-->
                @for (product of person.productEntities; track product; let itemIndex = $index) {
                  <div class="d-flex justify-content-between align-items-center w-100">
                    <div class="d-flex flex-column product-name">
                      @if (itemIndex === 0) {
                        <div class="person-name d-flex align-items-center">
                          <app-icon class="d-sm-none" [name]="'ageCategory' + person.ageCategoryType" />
                          {{ person.name }}
                        </div>
                      }
                      <!-- icon | name/price -->
                      <div class="d-flex align-items-center pt-1">
                        <app-icon name="damage" class="mr-2 d-none d-sm-inline-block" />
                        <div class="d-flex flex-column person-product-wrapper">
                          <span>{{
                            product.nameWithMerchantForAcceptedLanguages[translateService.currentLang]
                          }}</span>

                          <span class="slim-name">{{
                            'INSURANCE.productFeatureInsurance' | alpitranslate
                          }}</span>
                          @if (person.discounts) {
                            <span>
                              {{
                                insurableAddonFor(product).getOnlinePrice(
                                  cart.getDurationInDays(),
                                  person,
                                  product,
                                  cart.euroBasedRates,
                                  currencyService.actualCurrency
                                ) | alpicurrency: currencyService.actualCurrency
                              }}
                            </span>
                          } @else {
                            <span><app-icon name="circleNotch" /></span>
                          }
                        </div>
                      </div>
                    </div>
                    <div class="service-switch ml-2"></div>
                    <app-toggle
                      data-test="addProtectionButton"
                      [showButton]="true"
                      [state]="isInCart(product)"
                      (changedState)="changeInsuranceAddon(product, person)"
                      class="flex-shrink-0 d-flex align-items-center">
                    </app-toggle>
                  </div>
                }
              </div>
            </div>
          }
        }
      </div>
    </div>
  </div>
  <!-- Continue Button -->
  <div class="row button-wrapper">
    <div class="col-md-5 col-12 p-0"></div>
    <div class="col-md-7 col-12 p-0">
      <a
        class="btn btn-block btn-primary btn-primary-custom show-modal d-flex justify-content-center align-items-center px-0"
        (click)="continueToCheckout()"
        data-test="nextStepButtonProductUpsellingModal">
        {{ 'INSURANCE.continueButtonLabel' | alpitranslate }}
        <app-icon name="chevronRight" />
      </a>
    </div>
  </div>
</div>
